import choiceListApi from '@Apis/rehab.api';
import {
	type AssetTypeId,
	type SystemTypeId,
} from '@innovyze/lib_asset_schema';
import { type RehabQueryChoiceList } from '@Types';

export const getRehabRulesChoiceListApi = (
	systemType: SystemTypeId,
	assetType: AssetTypeId,
	recordType: string,
	inspectionStandard?: string,
	treeId?: string,
) => {
	const address = `/rehabTree/fieldsByRecordType/${recordType}`;
	return choiceListApi.get<RehabQueryChoiceList>(address, {
		params: {
			systemType: systemType.externalId,
			assetType: assetType.externalId,
			...(inspectionStandard ? { inspectionStandard } : {}),
			...(treeId ? { treeId } : {}),
		},
	});
};
